import { omit } from 'ramda'

const getCorrectSizedImage = (url): any => {
  if (!url) {
    return null
  }

  if (process.env.IS_CART_ITEM_IMAGE_NORMALIZER_ENABLED === 'disabled') return url

  const decodeImageMiniature = decodeURIComponent(url)
  const updateFile = decodeImageMiniature.replace(
    '[file:/product/cart]',
    '[file:/product/miniature]',
  )
  const updateRes = updateFile.replace('res[m]', 'res[q]')
  const encodedImageMiniature = encodeURIComponent(updateRes)

  return encodedImageMiniature || url
}

const normalizeItems = (items): any => {
  if (items === undefined || !items) {
    return []
  }

  return items.reduce((cartItems, cartItem) => {
    const updatedItem = {
      ...cartItem,
      productImage: {
        imageUrl: getCorrectSizedImage(cartItem.productImage?.imageUrl),
        text: cartItem.productImage?.text,
        showPrice: cartItem.productImage?.showPrice,
        id: cartItem.productImage?.id,
      },
    }

    return cartItems.concat(updatedItem)
  }, [])
}

export const normalizeCart = (cartResponse): any => {
  const cart = omit(['vouchersApplied'], cartResponse)

  return {
    ...cart,
    items: normalizeItems(cart?.items),
    oosItems: normalizeItems(cart?.oosItems),
    hazmatItems: normalizeItems(cart?.hazmatItems),
  }
}

const normalizeHiddenItem = (item): any => {
  return {
    title: item.productImage?.text,
    code: item.variantCode,
    removed: false,
    movedToFavourites: false,
  }
}

export const normalizeHiddenCart = (cartResponse): any => {
  const cartItems: any[] = []
  cartResponse.items?.forEach((cartItem) => {
    const hiddenCartData = normalizeHiddenItem(cartItem)
    cartItems.push(hiddenCartData)
  })
  cartResponse.oosItems?.forEach((cartItem) => {
    const hiddenCartData = normalizeHiddenItem(cartItem)
    cartItems.push(hiddenCartData)
  })
  cartResponse.hazmatItems?.forEach((cartItem) => {
    const hiddenCartData = normalizeHiddenItem(cartItem)
    cartItems.push(hiddenCartData)
  })
  return cartItems
}
